import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { RoleDetailFormService } from '../../role-details/services/role-detail-form.service';
import { createRole } from '../state/add-role.actions';
import { getAddRoleCallState } from '../state/add-role.selectors';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [RoleDetailFormService],
    selector: 'ndt-add-role',
    styleUrls: ['./add-role.component.scss'],
    templateUrl: './add-role.component.html',
    standalone: false
})
export class AddRoleComponent implements OnInit, OnDestroy, FormComponent {
   callState: Observable<CallState>;

   form: FormGroup;

   private destroyed$ = new Subject<void>();

   accountId: Observable<number | null>;

   constructor(
      protected store: Store,
      protected formService: RoleDetailFormService,
      private dialogService: LcsDialogService
   ) {
      this.accountId = store.select(getSelectedAccountId);
      this.callState = this.store.pipe(select(getAddRoleCallState));
   }

   ngOnInit(): void {
      this.form = this.formService.form;
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createRole({
               role: this.formService.getValue(null),
            })
         );
      }
   }
}
